import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { AccountTicketsActions } from './account-tickets.actions';

export interface AccountTicketsState {
    loaded: boolean;
    error: any;
    byId: any;
    allIds: any[];
    selectedId: number | string;
    emailTicketIds: any[];
    travelCardTicketIds: any[];
    voucherTicketIds: any[];
    voucherSubTicketIds: any[];
    selectedRelatedCardTicketIds: any[];
}
export const ACCOUNT_TICKETS_INITIAL_STATE: AccountTicketsState = {
    loaded: false,
    error: null,
    byId: {},
    allIds: [],
    selectedId: null,
    emailTicketIds: [],
    travelCardTicketIds: [],
    voucherTicketIds: [],
    voucherSubTicketIds: [],
    selectedRelatedCardTicketIds: []
};

export const ACCOUNT_TICKETS_STATE_KEY = 'account_tickets';

export function accountTicketsReducer(
    lastState: AccountTicketsState = ACCOUNT_TICKETS_INITIAL_STATE,
    action: RidangoReduxAction): AccountTicketsState {

    switch (action.type) {
        case AccountTicketsActions.FETCH_ACCOUNT_TICKETS:
            return tassign(lastState, {
                selectedId: null,
                loaded: false,
                error: null
            });
        case AccountTicketsActions.FETCH_ACCOUNT_TICKETS_SUCCESS:
            return tassign(lastState, {
                loaded: true,
                error: null,
                byId: action.payload.byId,
                allIds: action.payload.allIds
                    .filter((id, index, self) => self.indexOf(id) === index),
                emailTicketIds: action.payload.emailTicketIds
                    .filter((id, index, self) => self.indexOf(id) === index),
                travelCardTicketIds: action.payload.travelCardTicketIds
                    .filter((id, index, self) => self.indexOf(id) === index),
                voucherTicketIds: action.payload.voucherTicketIds
                    .filter((id, index, self) => self.indexOf(id) === index),
                voucherSubTicketIds: action.payload.voucherSubTicketIds
                    .filter((id, index, self) => self.indexOf(id) === index),

            });
        case AccountTicketsActions.FETCH_ACCOUNT_TICKETS_FAILED:
            return tassign(lastState, {
                loaded: true,
                error: action.payload
            });

        case AccountTicketsActions.FETCH_ACCOUNT_RELATED_CARD_TICKETS:
            return tassign(lastState, {
                selectedId: null,
                loaded: false,
                error: null
            });


        case AccountTicketsActions.FETCH_ACCOUNT_RELATED_CARD_TICKETS_FAILED:
            return tassign(lastState, {
                loaded: true,
                error: action.payload
            });

        case AccountTicketsActions.FETCH_ACCOUNT_RELATED_CARD_TICKETS_SUCCESS:
            return tassign(lastState, {
                loaded: true,
                error: null,
                byId: { ...lastState.byId, ...action.payload.byId },
                allIds: [...lastState.allIds, ...action.payload.allIds]
                    .filter((id, index, self) => self.indexOf(id) === index),
                selectedRelatedCardTicketIds: action.payload.selectedRelatedCardTicketIds


            });
        case AccountTicketsActions.SET_SELECTED_ACCOUNT_TICKET:
            return tassign(lastState, {
                selectedId: action.payload ? action.payload.doc_num : action.payload
            });
        case AccountTicketsActions.RESET_ACCOUNT_TICKETS:
            return tassign(lastState, ACCOUNT_TICKETS_INITIAL_STATE);

    }

    return lastState;
}


export interface AccountTicketsPartialStoreState {
    [ACCOUNT_TICKETS_STATE_KEY]: AccountTicketsState;
}
